//@ts-nocheck
import qs from 'qs'
import fetch from '../utils/fetch'

export const getUserInfo: any = async () => fetch.get('/sys-user/getUserInfo')

export const login: any = async (data) => fetch.post('/api/v1/noAuth/login', data)

// 注册
export const register: any = async (data) => fetch.post('/api/v1/noAuth/register', data)

// 发送验证码邮件
export const postCaptcha: any = async (params) => fetch.get('/api/v1/noAuth/captchaSms', { params })
export const getUserList: any = async (params) => fetch.get('/sys-user/page', { params })

//获取首页金额数据
export const getIndexMoney: any = async ({ params }) => fetch.get('/api/v1/statis/index/index_1', { params })

//业务方首页待办列表
export const getIndexTodo: any = async ({ params }) => fetch.get('/api/v1/statis/index/index_my_todo', { params })

//获取资方首页金额数据
export const getZfIndexMoney: any = async ({ params }) => fetch.get('/api/v1/statis/index/index_zf_1', { params })

//资方资方首页推荐列表
export const getMyPushList: any = async ({ params }) => fetch.get('/api/v1/statis/index/myPushList', { params })
